var smoothscroll = require("smoothscroll-polyfill");

require("katex/dist/katex.min.css");

smoothscroll.polyfill();